import { Card, FormGroup, Icon, InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useCreatePlaybook } from "../../hooks/use-create-playbook";
import { Button } from "../Button/button";
import { TagCreator } from "../TagCreator/tag-creator";
import { useSelectTagsPlaybook } from "../edit-play/hooks/use-select-tags-playbook";
import { Modal } from "../modal/modal";
import { MultiSelect } from "../multi-select";
import { Tag } from "../tag/tag";
import styles from "./create-playbook-dialog.module.scss";

export interface CreatePlaybookDialogProps {
  isOpen: boolean;
  onClose: () => void;
  playbookPlays: string[];
}

export const CreatePlaybookDialog = ({ isOpen, onClose, playbookPlays }: CreatePlaybookDialogProps) => {
  const [playbookName, setPlaybookName] = useState<string>("");
  const { createPlaybookWithDefaults } = useCreatePlaybook();
  const navigate = useNavigate();

  const [editingPlaybook, setEditingPlaybook] = useState({
    name: playbookName,
    playIds: playbookPlays,
    tags:[]
  });

  const updatePlaybookTags = (callback:any) => {
    setEditingPlaybook((prevState) => (callback(prevState)))
  }

  const { tagSelect } = useSelectTagsPlaybook({ editingPlaybook, updatePlaybookTags });
  
  /** Tag Creator */
  const [tagCreatorOpen, setTagCreatorOpen] = useState(false);
  const showTagCreator = () => {
    setTagCreatorOpen(true);
  };
  const hideTagCreator = () => {
    setTagCreatorOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    const playbook = await createPlaybookWithDefaults({
      ...editingPlaybook,
      name: playbookName,
      playIds:playbookPlays
    });

    handleClose();
    navigate(`/home/playbooks/${playbook.data.id}`);
  };

  const handleClose = () => {
    setPlaybookName("");
    onClose();
  };

  return (
    <Modal
      title="Create Playbook"
      isOpen={isOpen}
      onClose={handleClose}
      canOutsideClickClose
      isCloseButtonShown
      actions={[
        <Button intent="danger" text="Cancel" onClick={handleClose} minimal={true} key={1} />,
        <Button
          intent="primary"
          text="Create"
          onClick={handleSubmit}
          key={2}
          disabled={playbookName.length === 0}
        />,
      ]}
    >   
      <Card className={classNames(styles.formContainer)}>

      <FormGroup>
        <InputGroup
              placeholder="Playbook Name"
              value={playbookName}
              onChange={(e) => setPlaybookName(e.target.value)}
              onKeyDown={handleKeyDown}
              className={classNames(styles.input)}
          />
      </FormGroup>
      <FormGroup inline className={classNames(styles.tagMultiSelect)}>
            <MultiSelect
              {...tagSelect}
              fill
              placeholder="Select Tags"
              tagRenderer={(tag) => (
                <div data-color={tag.color} data-text-color={tag.textColor}>
                  {tag.name}
                </div>
              )}
              tagInputProps={{
                tagProps: (value: any) => {
                  const color: string | undefined = value?.props?.["data-color"];
                  const textColor: string | undefined = value?.props?.["data-text-color"];
                  return { style: { backgroundColor: color, color: textColor }, rightElement:null };
                },
              }}
              itemRenderer={(item) => <Tag tag={item} />}
            />
            <Icon icon="add" onClick={showTagCreator} className={styles.tagCreator} />
      </FormGroup>
      </Card>


      <TagCreator show={tagCreatorOpen} handleClose={hideTagCreator} updatePlay={updatePlaybookTags} />
    </Modal>
  );
};
